import { Link, useParams } from "react-router-dom";
import { NEWS, CATEGORIES } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";
import NewsletterForm from "@/components/feature/NewsletterForm";
import { formatViews, getCategoryColor } from "@/utils/format";
import useSeo from "@/hooks/useSeo";

export default function NewsDetailPage() {
  const { slug } = useParams();
  const item = NEWS.find((n) => n.slug === slug) || NEWS[0];

  useSeo({
    title: `${item.title} - 娱乐爆料`,
    description: item.summary,
    keywords: `娱乐爆料,${item.category},${item.tag},明星动态`,
  });

  const related = NEWS.filter((n) => n.categorySlug === item.categorySlug && n.id !== item.id).slice(0, 3);
  const aside = NEWS.filter((n) => n.id !== item.id).sort((a, b) => b.views - a.views).slice(0, 5);

  const schema = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: item.title,
    description: item.summary,
    author: { "@type": "Person", name: item.author },
    datePublished: item.date,
    image: item.cover,
    articleSection: item.category,
  };

  return (
    <div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      {/* 顶部图 */}
      <section className="relative overflow-hidden bg-foreground-950">
        <div className="mx-auto flex max-w-7xl flex-col justify-end px-4 py-10 md:px-6 md:py-14">
          <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-sm text-background-300">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to={`/category/${item.categorySlug}`} className="hover:text-background-100">{item.category}</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-100">正文</span>
          </nav>
          <h1 className="mt-4 max-w-4xl text-2xl font-black leading-snug text-background-50 md:text-4xl md:leading-snug">{item.title}</h1>
          <div className="mt-5 flex flex-wrap items-center gap-4 text-sm text-background-200">
            <span className="inline-flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500 text-background-50"><i className="ri-quill-pen-fill text-sm"></i></span>
              作者：{item.author}
            </span>
            <span className="inline-flex items-center gap-1"><i className="ri-calendar-line"></i>{item.date}</span>
            <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{formatViews(item.views)} 阅读</span>
            <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i>{item.comments} 评论</span>
          </div>
        </div>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          {/* 正文 */}
          <article className="lg:col-span-2">
            <figure className="overflow-hidden rounded-lg">
              <img src={item.cover} alt={item.alt} className="w-full object-cover" />
              <figcaption className="mt-2 text-xs text-foreground-400">{item.alt}</figcaption>
            </figure>
            <div className="mt-6 flex flex-wrap items-center gap-2">
              <span className={`rounded px-2.5 py-1 text-xs font-semibold ${getCategoryColor(item.categorySlug)}`}>{item.category}</span>
              {item.exclusive && <span className="rounded bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">独家首发</span>}
              <span className="rounded bg-background-100 px-2.5 py-1 text-xs text-foreground-600">{item.tag}</span>
            </div>
            <p className="mt-6 rounded-lg border-l-4 border-primary-500 bg-background-100 p-5 text-base font-medium leading-relaxed text-foreground-800">
              {item.summary}
            </p>
            <div className="mt-8 space-y-6">
              {item.content.map((para, i) => (
                <p key={i} className="text-[15px] leading-[1.9] text-foreground-700 md:text-base">
                  {para}
                </p>
              ))}
            </div>

            {/* 分享 */}
            <div className="mt-10 flex flex-wrap items-center justify-between gap-4 border-y border-background-200 py-5">
              <div className="flex items-center gap-2">
                <span className="text-sm font-semibold text-foreground-700">分享到：</span>
                {[
                  { icon: "ri-weibo-fill", label: "微博" },
                  { icon: "ri-wechat-fill", label: "微信" },
                  { icon: "ri-send-plane-fill", label: "私信好友" },
                  { icon: "ri-file-copy-line", label: "复制链接" },
                ].map((s) => (
                  <button key={s.label} onClick={() => {}} aria-label={s.label} className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50">
                    <i className={s.icon}></i>
                  </button>
                ))}
              </div>
              <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-400">
                <span className="inline-flex items-center gap-1"><i className="ri-fire-fill text-primary-500"></i>{formatViews(item.views)} 热度</span>
                <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i>{item.comments} 评论</span>
              </div>
            </div>

            {/* 编辑导语订阅 */}
            <div className="mt-8 rounded-lg bg-accent-50 p-6">
              <h2 className="text-base font-black text-foreground-950">不错过任何第一手爆料？</h2>
              <p className="mt-1 text-sm text-foreground-600">留下邮箱，娱乐爆料每日为你推送最新鲜的娱乐资讯。</p>
              <NewsletterForm compact className="mt-4" />
            </div>

            <p className="mt-6 text-xs leading-relaxed text-foreground-400">
              免责声明：本文部分资讯来源于公开网络，仅供娱乐参考，不代表本站立场。如涉及版权问题，请联系我们删除。
            </p>
          </article>

          {/* 侧栏 */}
          <aside className="space-y-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="mb-4 flex items-center gap-2 text-lg font-black text-foreground-950">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50"><i className="ri-fire-fill text-base"></i></span>
                热门阅读
              </h2>
              <ol className="space-y-1">
                {aside.map((n, idx) => (
                  <li key={n.id}>
                    <Link to={`/news/${n.slug}`} className="group flex items-start gap-3 rounded-md px-2 py-2 hover:bg-background-50">
                      <span className={`mt-0.5 w-5 shrink-0 text-center font-display text-base font-bold ${idx < 3 ? "text-primary-600" : "text-foreground-300"}`}>{idx + 1}</span>
                      <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 group-hover:text-primary-700">{n.title}</span>
                    </Link>
                  </li>
                ))}
              </ol>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="mb-4 text-lg font-black text-foreground-950">栏目导航</h2>
              <div className="flex flex-wrap gap-2">
                {CATEGORIES.filter((c) => c.slug !== "all").map((c) => (
                  <Link key={c.slug} to={`/category/${c.slug}`} className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50">
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </div>

      {/* 相关推荐 */}
      {related.length > 0 && (
        <section className="border-t border-background-200 bg-background-100">
          <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
            <h2 className="mb-6 text-xl font-black text-foreground-950 md:text-2xl">相关推荐</h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {related.map((n) => <NewsCard key={n.id} item={n} />)}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}